<template>
  <section
    ref="top"
    class="business-list"
  >
    <div class="business-list__row">
      <div class="business-list__column business-list__column--left">
        <div class="business-list__header">
          <h2
            v-if="!businessRequestParams.keyword && businesses.length"
            class="business-list__heading business-list__heading--h2"
          >
            Businesses
          </h2>

          <h2
            v-else-if="
              businessRequestParams.keyword && businesses.length && !loading
            "
            class="business-list__heading business-list__heading--h2"
          >
            Results for "{{ businessRequestParams.keyword }}"
            <button
              class="business-list__clear"
              @click="handleKeywordRemove"
            >
              <span class="hidden-text">Remove search query</span>
              <img
                src="/img/icon/clear.svg"
                alt="Remove search query"
                class="business-list__icon-clear"
              >
            </button>
          </h2>
          <h2
            v-else-if="!loading"
            class="business-list__heading business-list__heading--h2"
          >
            No results found
          </h2>
        </div>

        <div
          v-if="!businesses.length && !loading"
          class="business-list__empty"
        >
          <p class="business-list__paragraph">
            <strong>Sorry, no businesses were found. Here are some tips to improve
              your search:</strong>
          </p>
          <ul class="business-list__list">
            <li>Remove your category selection</li>
            <li>Choose a less specific search keyword</li>
            <li>
              <a href="/contact"><strong>Contact us</strong></a> to have your
              business listed
            </li>
          </ul>
        </div>

        <BusinessListCard
          v-for="business in businesses"
          :key="business.id"
          :ref="business.id"
          :business="business"
          :active-business="activeBusiness"
          :keyword="businessRequestParams.keyword"
        />

        <Pagination
          v-if="pagination.pageCount > 0 && businesses.length"
          :pagination="pagination"
          @updatePagination="updatePagination"
        />
      </div>
      <div class="business-list__column business-list__column--right">
        <div
          ref="stickyElement"
          class="google-map"
        >
          <GoogleMap
            style="width: 100%; height: 600px"
            :businesses="
              businesses.filter((business) => business.lat && business.lng
                && business.lat != 0 && business.lng != 0
                && business.address_1 &&
                business.city &&
                business.state_province)
            "
            @updateActiveBusiness="updateActiveBusiness"
          />

          <!--
          <a
            href="https://winnipeg-chamber.com/contest/"
            target="_blank"
          >
            <img
              id="main_page_ads"
              src="/img/ads/business_right_bar_horizontal.jpg"
              alt="business_right_bar"
              style="margin-top: 0.5rem;width: 100%;height: 252px"
            >
          </a>

          <a
            href="https://winnipeg-chamber.com/contest/"
            target="_blank"
          >
            <img
              id="main_page_ads_mobile"
              src="/img/ads/business_right_bar_mobile.jpg"
              alt="business_right_bar_mobile"
              style="margin-top: 0.5rem;width: 100%;"
            >
          </a>
          -->
        </div>
      </div>
    </div>
    <Cookie ref="cookie" />
  </section>
</template>
<script>
    import BusinessListCard from './BusinessListCard.vue';
    import Pagination from './Pagination.vue';
    import GoogleMap from './GoogleMap.vue';
    import Cookie from './Cookie.vue';

    export default {
  components: {
    BusinessListCard,
    GoogleMap,
    Pagination,
    Cookie
  },
  props: {
    apiRoutes: { required: true, type: Object },
  },
  data() {
    return {
        loading: true,
        isMobile: true,
        pageUrl: window.location.href.split('?')[0],
        address: {
            subdirectories: '',
            params: {},
        },
        businesses: [],
        pagination: {
            page: 1,
            pageCount: 0,
            resultCount: 0,
            from: 0,
            to: 0,
        },
        businessRequestParams: {
            order_by: 'asc',
            sort_by: 'name',
            filter_by: 'category.slug',
            city: null,
            proximity: null,
            lat: null,
            lng: null,
            filter: null,
            keyword: null,
            page: 1,
            limit: 25,
        },
        activeBusiness: null,
    };
  },
  mounted() {
      window.addEventListener('popstate', (event) => {
          this.checkAddressBar().then((resolve) => {
              this.loadBusinesses();
          });
      });
      window.onload = () => {
          this.checkIfMobile();
      };
      window.onresize = () => {
          this.checkIfMobile();
      };
      this.checkAddressBar().then((resolve) => {
          this.loadBusinesses(true);
      });
  },
  methods: {
      checkIfMobile() {
          if (window.innerWidth > 768) {
              this.isMobile = false;
          }
      },
      opened() {
          Vue.nextTick(() => {
              const active = this.$refs.select.$el.querySelector(
                  '.vs__dropdown-menu .vs__dropdown-option--selected',
              );
              if (active) {
                  active.scrollIntoView({
                      behavior: 'instant',
                      block: 'center',
                  });
              }
          });
      },
      scrollToActiveBusiness(business) {
          let activeBusinessRef = this.$refs[business.id];
          const elementPosition = activeBusinessRef[0].$el.getBoundingClientRect()
              .top;
          let offsetPosition =
              elementPosition -
              (window.innerHeight - activeBusinessRef[0].$el.clientHeight) / 2;
          if (window.scrollY > 0) {
              // This only works when scrolled some distance from the top
              activeBusinessRef[0].$el.scrollIntoView({
                  behavior: 'auto',
                  block: 'center',
                  inline: 'center',
              });
          } else {
              // This only works when not scrolled any distance from the top
              window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth',
              });
          }
      },
      updateActiveBusiness(business) {
          if (business) {
              if (!this.isMobile) {
                  this.scrollToActiveBusiness(business);
              }
              this.activeBusiness = business.id;
          } else {
              this.activeBusiness = null;
          }
      },
      requestBusinesses() {
          let data = {
              params: this.businessRequestParams,
          };
          const request = axios.get(this.apiRoutes.businesses, data);
          return request;
      },
      loadBusinesses(updateAddressBar = false) {
          if (updateAddressBar) this.updateAddressBar();
          this.requestBusinesses()
              .then((response) => {
                  this.businesses = response.data.data;
                  this.pagination.page = response.data.meta.current_page;
                  this.pagination.from = response.data.meta.from;
                  this.pagination.to = response.data.meta.to;
                  this.pagination.resultCount = response.data.meta.total;
                  this.pagination.pageCount = response.data.meta.last_page;
                  if (updateAddressBar) this.updateAddressBar();
                  this.$nextTick(() => {
                      this.loading = false;
                  });
              })
              .catch((error) => {
                  let response = error.response;
                  this.loading = false;
                  console.log(response);
              });
      },
      updatePagination(prev, next, page = null) {
          if (prev) Number((this.businessRequestParams.page -= 1));
          if (next) Number((this.businessRequestParams.page += 1));
          if (page) Number((this.businessRequestParams.page = page));
          const top = this.$refs.top;
          top.scrollIntoView(/*{ behavior: 'smooth' }*/);
          top.focus();
          this.loadBusinesses(true);
      },
      checkAddressBar() {
          const url = new URL(window.location.href);
          if (url.search) {
              const parameters = url.search.replace('?', '').split('&');
              parameters.forEach((parameter) => {
                  console.log(parameter);
                  if(!!parameter) {
                      let name = parameter.split('=')[0];
                      let value = decodeURIComponent(
                          parameter.split('=')[1].replace('+', ' '),
                      );
                      if (value)
                          this.businessRequestParams[name] = value !== 'null' ? value : null;
                  }
              });
          }
          if (url.pathname.includes('tag/')) {
              this.businessRequestParams.filter = url.pathname.split('tag/')[1].replace('/', '');
          }
          return new Promise((resolve, reject) => {
              resolve();
          });
      },
      updateAddressBar() {
          const pageUrl = this.pageUrl.endsWith('/')
              ? this.pageUrl
              : `${this.pageUrl}/`;
          let newUrl = new URL(pageUrl);
          if (this.businessRequestParams.filter) {
              newUrl.pathname = `/businesses/tag/${this.businessRequestParams.filter}/`;
          } else {
              newUrl.pathname = `/businesses/`;
          }
          newUrl.search += `&page=${this.businessRequestParams.page}`;
          history.pushState(null, null, newUrl);
      },
  },
};
</script>
